import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { AngularFireAuth } from 'angularfire2/auth';
import * as firebase from 'firebase/app';
import { UserService } from './user.service';
import { environment } from '../environments/environment';

@Injectable()
export class LoggedInGuard implements CanActivate {
  user: Observable<firebase.User>;

  constructor(private router: Router, public afAuth: AngularFireAuth, public userService: UserService) {
    this.user = afAuth.authState;
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean>|Promise<boolean>|boolean {

    return new Promise((resolve) => {
      this.userService.userIsLoggedIn().then(value => {
        if(value) {
          resolve(true);
        } else {
          this.router.navigate(['/login']);
          resolve(false);
        }
      });

    });

  }
}



// WEBPACK FOOTER //
// /Users/mac-jeremy/Projets/fairepart/src/app/loggedInGuard.service.ts